import { combineReducers } from 'redux';
import requirements from './requirements';
import sites from './sites';
import diagnostic from './diagnostic';
import tools from './tools';
import errors from './errors';
import dirty from './dirty';

export const caseReducer = combineReducers({
  requirements,
  sites,
  diagnostic,
  tools,
  errors,
  dirty,
});



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/reducers/index.js